'use client';

import { Select } from '@app/app/_components/Input/Select/Select';
import { Input } from '@app/app/_components/Input/Input';
import { ViolationMap } from '@app/lib/form/contracts/ViolationMap';
import { useTranslations } from 'next-intl';
import { Message } from '@app/app/_components/Message/Message';
import { Bank } from '@app/domain/model/Bank';
import { SessionResponse } from '@app/domain/model/eshop/life/session/SessionResponse';
import { useState } from 'react';

interface Props {
    violations?: ViolationMap;
    sessionData?: Nullable<SessionResponse>;
}

export function EInvoiceStep({ violations, sessionData }: Props) {
    const t = useTranslations();

    const [bank, setBank] = useState<string>('');

    const handleBankChange = (value: string) => {
        setBank(value);
    };

    const bankOptions = [
        { value: Bank.Swedbank, label: t('eshop.life.banks.swedbank') },
        { value: Bank.Seb, label: t('eshop.life.banks.seb') },
        { value: Bank.Luminor, label: t('eshop.life.banks.luminor') },
        { value: Bank.Lhv, label: t('eshop.life.banks.lhv') },
        { value: Bank.CoopPank, label: t('eshop.life.banks.coopPank') },
        { value: Bank.NoEInvoice, label: t('eshop.life.banks.noEInvoice') },
    ];

    return (
        <div className="flex flex-col gap-8">
            <Message variant="info">{t('eshop.life.eInvoiceDescription')}</Message>

            <Select
                name="bank"
                label={t('eshop.life.bank')}
                options={bankOptions}
                placeholder={t('eshop.life.selectBank')}
                error={violations?.bank}
                onChange={handleBankChange}
                defaultValue={sessionData?.thirdStep?.eInvoice?.bank}
            />

            {bank !== Bank.NoEInvoice && (
                <Input
                    name="currentAccountNumber"
                    label={t('eshop.life.currentAccountNumber')}
                    placeholder={t('eshop.life.currentAccountNumberPlaceholder')}
                    error={violations?.currentAccountNumber}
                    noSpaces
                    defaultValue={sessionData?.thirdStep?.eInvoice?.currentAcountNumber}
                />
            )}
        </div>
    );
}
